export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift()
    return cookieValue || null
  }

  return null
}

export function setCookie(
  name: string,
  value: string,
  options?: {
    expires?: Date | string
    path?: string
    domain?: string
    secure?: boolean
    sameSite?: 'Strict' | 'Lax' | 'None'
  }
): void {
  let cookieString = `${name}=${value}`

  if (options?.expires) {
    const expiresString = options.expires instanceof Date
      ? options.expires.toUTCString()
      : options.expires
    cookieString += `; expires=${expiresString}`
  }

  if (options?.path) {
    cookieString += `; path=${options.path}`
  }

  if (options?.domain) {
    cookieString += `; domain=${options.domain}`
  }

  if (options?.secure) {
    cookieString += '; secure'
  }

  if (options?.sameSite) {
    cookieString += `; SameSite=${options.sameSite}`
  }

  document.cookie = cookieString
}

export function deleteCookie(name: string, path: string = '/'): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`
}

export function hasCookie(name: string): boolean {
  return getCookie(name) !== null
}
